import { getAuth } from "firebase/auth";
import { getFirebaseApp } from "./getFirebaseApp";
export function getFirebaseAuth() {
  return getAuth(getFirebaseApp());
}
